import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campKcrNew: FaireAdCampaignEntity = {
  token: "camp_kcr_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_keystone_crystals",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 2222,
  startedRunningAt: "2024-08-21",
  segmentMetrics: {
    numCustomersAcquired: 232,
    salesDollars: 107986,
    totalAdsSpendDollars: 14918,
    cpaDollars: 64.3,
    bestEstimateSalesDollars: 113419,
    bestEstimateRoas: 7.6,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
